import script from "./VariantDetailsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./VariantDetailsPage.vue?vue&type=script&setup=true&lang=js"

import "./VariantDetailsPage.vue?vue&type=style&index=0&id=504b0103&lang=css"

const __exports__ = script;

export default __exports__